import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import useEmailField from './useEmailField';
import { AccountFieldsetField as Field } from '../../AccountFieldset.style';
import { EMAIL_MAX_LENGTH } from '../../constants';

const MESSAGE_IDS = {
  label: 'shopping.component.accountFieldset.emailField.label'
};

function EmailField({
  defaultValue,
  namePrefix,
  readOnly,
  validation,
  value: valueProp,
  ...delegated
}) {
  const { formatMessage } = useIntl();
  const { error, field } = useEmailField({ defaultValue, namePrefix, validation });

  const isDisabled = readOnly || delegated.disabled;

  const autoFocus = !isDisabled && delegated.autoFocus;
  const errorProp = !readOnly ? error : null;
  const fieldProps = !readOnly ? field : {};
  const value = readOnly ? valueProp : field.value;

  const inputProps = {
    'data-testid': 'email-input',
    autoComplete: 'email',
    inputMode: 'email',
    maxLength: EMAIL_MAX_LENGTH
  };

  return (
    <Field
      autoFocus={autoFocus}
      label={formatMessage({ id: MESSAGE_IDS.label })}
      type="email"
      {...delegated}
      {...fieldProps}
      error={errorProp}
      InputProps={{ inputProps }}
      readOnly={readOnly}
      value={value}
    />
  );
}

EmailField.propTypes = {
  defaultValue: PropTypes.string,
  namePrefix: PropTypes.string,
  readOnly: PropTypes.bool,
  validation: PropTypes.object,
  value: PropTypes.string
};

export default EmailField;
